import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class LoadingContainer extends BaseComponent {
	properties() {
		return {
			isLoading: false,
			context: 'document', // 'document|parent|this'
			delay: undefined, // in ms
		};
	}

	connected() {
		let context = document;
		if (this.context === 'parent') context = this.element.parentElement;
		if (this.context === 'this') context = this.element;

		context.addEventListener('loading-start', (e) => {
			this.isLoading = true;
		});
		context.addEventListener('loading-end', (e) => {
			if (this.delay) {
				setTimeout(() => {
					this.isLoading = false;
				}, parseInt(this.delay));
			} else {
				this.isLoading = false;
			}
		});

		if (this.element.classList.contains('is-loading') && !this.element.hasAttribute('is-loading')) {
			this.isLoading = true;
		} else if (this.isLoading === true) {
			this.element.classList.toggle('is-loading', true);
		}
	}

	watch() {
		return {
			isLoading: (isLoading) => {
				this.element.classList.toggle('is-loading', isLoading);
			},
		};
	}
}

defineComponent('loading-container', LoadingContainer);
